'use client';

import { useEffect, useState } from 'react';
import { useBranding } from '@/app/hooks/useBranding';
import { useForceHomeGuard } from '@/app/hooks/useForceHomeGuard';
import FullPageSpinner from '@/app/components/loading/FullPageSpinner';
import { LandingPage } from '@/app/features/landing/components/LandingPage';

/**
 * Global SmartMatrix landing page (`/`).
 *
 * A thin wrapper over the shared `LandingPage` component (spec:
 * tenant-landing-page): renders it with the operator's global branding and
 * sends the "Explore Our Solution" CTA into the app at `/main`. Per-tenant
 * landings live at `/welcome/{tenantCode}`.
 */
export default function Home() {
  const branding = useBranding();
  const showForceHomeGuard = useForceHomeGuard();
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  // Hold a spinner while a force-home redirect is imminent — the TenantLoader
  // route guard redirects white-label users away from `/`.
  if (isClient && showForceHomeGuard) {
    return <FullPageSpinner />;
  }

  return <LandingPage branding={branding} exploreHref="/main" />;
}
